// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2welZ","label":"LabeledBox_label__1Pwi0"};